import { Children, type PropsWithChildren, cloneElement, isValidElement } from 'react';
import { Modal as ReactModal } from 'react-bootstrap';
import { useModalContext } from './ModalContext';
import { Button } from '../Button';

export type ModalFooterProps = {
  className?: string;
};
export const ModalFooter = (props: PropsWithChildren<ModalFooterProps>) => {
  const { className, children } = props;
  const { color } = useModalContext();

  const footerChildren = Children.map(children, child => {
    return isValidElement<{ purpose?: string }>(child) && child.type === Button && child.props.purpose === 'primary'
      ? // @ts-ignore
      cloneElement<ButtonProps>(child, { color })
      : child;
  });

  return <ReactModal.Footer className={className}>{footerChildren}</ReactModal.Footer>;
};
